// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2BpSL","footer":"ModalInfo_footer__1IS4j"};